import { API_RESPONSE } from '../_const';

export const useSpecialSubAccountApi = ({ axios }) => {
  const fetchList = ({ page, pageSize, memberId = 0 }) => {
    page = Number.parseInt(page, 10) || 1;
    pageSize = Number.parseInt(pageSize, 10) || 10;
    memberId = Number.parseInt(memberId, 10) || 0;

    return new Promise((resolve, reject) => {
      axios
        .post('SpecialSubAccount/List', {
          page,
          pageSize,
          memberId,
        })
        .then((response) => {
          if (
            response &&
            response.code === API_RESPONSE.SUCCESS &&
            response.data
          ) {
            resolve(response.data);
          } else {
            throw new Error(response.message || '無法取得相關資料列表');
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const fetchCBList = ({ keyword }) => {
    keyword = keyword || '';

    return new Promise((resolve, reject) => {
      axios
        .post('SpecialSubAccount/CBList', {
          keyword,
        })
        .then((response) => {
          if (
            response &&
            response.code === API_RESPONSE.SUCCESS &&
            response.data
          ) {
            resolve(response.data);
          } else {
            throw new Error(response.message || '無法取得相關資料列表');
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const fetchDetail = (dataId) => {
    dataId = Number.parseInt(dataId, 10) || 0;

    return new Promise((resolve, reject) => {
      axios
        .get(`SpecialSubAccount/Detail/${dataId}`)
        .then((response) => {
          if (
            response &&
            response.code === API_RESPONSE.SUCCESS &&
            response.data
          ) {
            resolve(response.data);
          } else {
            reject(new Error(response.message || '無法取得相關資料明細'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const createNewData = (formDto) => {
    formDto = formDto || {};

    delete formDto.id;

    return new Promise((resolve, reject) => {
      axios
        .post('SpecialSubAccount/Insert', formDto)
        .then((response) => {
          if (response && response.code === API_RESPONSE.SUCCESS) {
            resolve(true);
          } else {
            reject(new Error(response.message || '無法新增該筆資料'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const updateData = (formDto) => {
    formDto = formDto || {};

    formDto.id = Number.parseInt(formDto.id, 10) || 0;

    return new Promise((resolve, reject) => {
      axios
        .put('SpecialSubAccount/Update', formDto)
        .then((response) => {
          if (response && response.code === API_RESPONSE.SUCCESS) {
            resolve(true);
          } else {
            reject(new Error(response.message || '無法更新該筆資料'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const deleteData = (dataId) => {
    dataId = Number.parseInt(dataId, 10) || 0;

    return new Promise((resolve, reject) => {
      axios
        .delete(`SpecialSubAccount/Delete/${dataId}`)
        .then((response) => {
          if (response && response.code === API_RESPONSE.SUCCESS) {
            resolve(true);
          } else {
            reject(new Error(response.message || '無法刪除該筆資料'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const fetchRequiredFlag = () => {
    return new Promise((resolve, reject) => {
      axios
        .get('SpecialSubAccount/FetchRequiredFlag')
        .then((response) => {
          if (
            response &&
            response.code === API_RESPONSE.SUCCESS &&
            response.data
          ) {
            resolve(response.data);
          } else {
            reject(new Error(response.message || '無法取得會員相關設定'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const updateRequiredFlag = (flagRequired) => {
    flagRequired = flagRequired === true;

    return new Promise((resolve, reject) => {
      axios
        .put('SpecialSubAccount/UpdateRequiredFlag', {
          flagRequired,
        })
        .then((response) => {
          if (response && response.code === API_RESPONSE.SUCCESS) {
            resolve(true);
          } else {
            reject(new Error(response.message || '無法變更特殊分帳必填之設定'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    fetchList,
    fetchCBList,
    fetchDetail,
    createNewData,
    updateData,
    deleteData,
    fetchRequiredFlag,
    updateRequiredFlag,
  };
};
